/* eslint-disable @typescript-eslint/no-explicit-any */
import FeatureBannerV1 from '~/components/Content/Banners/Core/Feature/Variant1/FeatureBannerV1'
import FeatureBannerV2 from '~/components/Content/Banners/Core/Feature/Variant2/FeatureBannerV2'
import { default as FeatureBannerV1AG } from '~/components/Content/Banners/AvantGarde/Feature/Variant1/FeatureBannerV1'
import { default as FeatureBannerV2AG } from '~/components/Content/Banners/AvantGarde/Feature/Variant2/FeatureBannerV2'
import NextSteps from '~/components/Content/NextSteps/NextSteps'

const componentMap = {
  contentFeatureBannerV1: FeatureBannerV1,
  contentFeatureBannerV2: FeatureBannerV2,
  contentFeatureBannerV1AG: FeatureBannerV1AG,
  contentFeatureBannerV2AG: FeatureBannerV2AG,
  contentNextSteps: NextSteps
} as any

{
  /*
  CMS:
  - contentSearchBlock
  */
}

export function loadComponent(cmsComponentName: string) {
  // Uses the list of Layout names above and matches it to the correct Layout
  return componentMap[cmsComponentName]
}
